
// import React, { useEffect } from 'react';
// import { Wallet } from '@mercadopago/sdk-react';

// function WalletButton ({ setIsLoadingMePaButton, preference }) {

//   return (
//     <div>
//       <p className='font-bold pl-2'>Paga con trajeta de Crédito o Debito:</p>
//       <Wallet
//           initialization={{preferenceId: `${preference.id}`}}
//           onReady={() => setIsLoadingMePaButton(false)}
//       />
//     </div>
//   );
// };

// export default WalletButton;

import React from "react";
import { Wallet } from "@mercadopago/sdk-react";

function WalletButton({ setIsLoadingMePaButton, preference }) {
    return (
        <div className="mx-3 mt-2 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-sm">
            <div className="px-4 py-3 bg-[#f7f4ef] border-b border-gray-100 flex items-center gap-2">
                <svg className="w-4 h-4 text-[#a02338]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="5" width="20" height="14" rx="2"/><line x1="2" y1="10" x2="22" y2="10"/>
                </svg>
                <p className="text-sm font-semibold text-[#2a1419]">Pago con tarjeta</p>
            </div>
            <div className="px-4 py-3">
                <p className="text-[12px] text-gray-400 mb-3">
                    Crédito o débito — procesado por Mercado Pago
                </p>
                <Wallet
                    initialization={{ preferenceId: `${preference.id}` }}
                    onReady={() => setIsLoadingMePaButton(false)}
                />
            </div>
        </div>
    );
}

export default WalletButton;
